// Port of api/fuel/app/classes/insights/players/overview.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'

export default Segment.extend({
	name: 'overview',
	priority: -1,
	requires: ['init'],
	types: [Constants.TYPE_USER],
	insight: false,
	run: function() {
		var players = this._data.players || []
		var plays = Object.keys(this._data.plays || {}).map(function(key) { return this._data.plays[key] }.bind(this))
		var plays5 = players.filter(function(player) { return player.totalPlays >= 5 })
		var plays10 = players.filter(function(player) { return player.totalPlays >= 10 })
		var plays25 = players.filter(function(player) { return player.totalPlays >= 25 })
		var p2 = plays.filter(function(play) { return play.pl === 2 }).length
		var groups = 0
		var groupKeys = {}

		for (var i = 0; i < plays.length; i++) {
			if (plays[i].pl > 2 && !groupKeys[plays[i].playersKey]) {
				groupKeys[plays[i].playersKey] = true
				groups++
			}
		}

		return {
			overview: {
				total: players.length,
				games: (this._data.games || []).length,
				plays: plays.length,
				groups: groups,
				head2head: players.filter(function(player) {
					var counts = Object.keys(player.counts || {})
					return counts.length && counts.indexOf('2') !== -1
				}).length,
				split: [p2, plays.length - p2],
				plays5: plays5.length,
				plays10: plays10.length,
				plays25: plays25.length
			}
		}
	}
})
